import StatisticsTickDate from './component';

export default StatisticsTickDate;
